/* L'Apprêt — pastille de comptage du signet d'en-tête */
(function () {
  function count() {
    try { return (JSON.parse(localStorage.getItem('la-pieces-marquees')) || []).length; }
    catch (e) { return 0; }
  }
  function refresh() {
    var n = count();
    document.querySelectorAll('[data-la-bubble]').forEach(function (b) {
      var c = b.querySelector('[data-la-bubble-count]');
      if (c) c.textContent = n;
      b.hidden = (n === 0);
    });
  }
  document.addEventListener('la:marques:change', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', function (e) {
    if (e.key === 'la-pieces-marquees') refresh();
  });
})();